module.exports = __webpack_public_path__ + "img/icon_wangzhanjianshe.e0fa4aa9.png";